import { useSearch } from '@tanstack/react-router'
import { AdminFinanceScreen } from '@features/admin/ui/AdminFinanceScreen'
import { useAdminUserLookup } from '@features/admin/api/admin.api'
import { ErrorState, Skeleton } from '@shared/design-system/ui'

export function FinancasPage() {
  const { userId } = useSearch({ strict: false })
  const lookup = useAdminUserLookup(userId ?? '')
  if (userId && lookup.isPending) return <Skeleton />
  if (userId && (lookup.isError || !lookup.data?.user)) {
    return <ErrorState title="Não foi possível abrir o extrato desta pessoa" />
  }
  return (
    <AdminFinanceScreen
      key={userId ?? 'all'}
      {...(lookup.data?.user ? { initialUser: lookup.data.user } : {})}
    />
  )
}
